import { ServiceModel } from '../service-catalog/model';

export class SelfDiagnosisModel {
  public id: number;
  public nameUa: string = '';
  public nameRu: string = '';
  public orderNumber: number;
  public keyWords: string;
  public typeId: number = 1;
  public priority: number = 0;
  public serviceId: number;
  public service: ServiceModel;
  public selfDiagnosisSteps: SelfDiagnosisStepModel[] = [];
  public iconBody: string;
  public iconType: string;
}

export class SelfDiagnosisStepModel {
  public id: number = 0;
  public bodyUa: string;
  public bodyRu: string;
  public orderNumber: number = 0;
  public selfDiagnosisId: number = 0;
}

export class SelfDiagnosisStepRateModel {
  public selfDiagnosisStepId: number = null;
  public employeeId: number = null;
  public value: number = null;

  constructor(values: SelfDiagnosisStepRateModel) {
    Object.assign(this, values);
  }
}
